import { useDeviceType } from '@cian/ui-kit';
import { Title } from '../Title';
import * as style from './ProtectYou.css';
import clsx from 'clsx';

interface IProtectYouProps {
  accordion: JSX.Element;
}

export const ProtectYou: React.FC<IProtectYouProps> = ({ accordion }) => {
  const device = useDeviceType();

  return (
    <div
      id="insurance"
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['title-container']}>
        <div className={style['title']}>
          <Title>Защитим вас и жильца от неожиданностей</Title>
        </div>
        <div className={style['descr']}>
          Страховка — отличная альтернатива депозиту: арендатор платит небольшие ежемесячные взносы, а ваша квартира
          остаётся под защитой.
        </div>
      </div>
      {accordion}
    </div>
  );
};
